import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

export function fileUrl(u) {
    if (u && u.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${u}`;
    return u;
}

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Terjadi kesalahan. Coba lagi.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export function trackPage(page) {
    try {
        let visitorId = localStorage.getItem("mandalika_vid");
        if (!visitorId) {
            visitorId = crypto.randomUUID();
            localStorage.setItem("mandalika_vid", visitorId);
        }
        api.post("/track", { page, visitor_id: visitorId }).catch(() => {});
    } catch (e) {
        // Analitik bersifat best-effort; jangan ganggu pengalaman pengguna.
    }
}
